import { registerContextMenuListener } from './handlers/disable-native-context-menu';

/**
 * Registers event listeners.
 *
 * @returns A cleanup function that removes all registered event listeners
 */
export function setupEventListeners(): () => void {
  const cleanupFunctions: (() => void)[] = [];

  const contextMenuCleanup = registerContextMenuListener();

  cleanupFunctions.push(contextMenuCleanup);

  // Return cleanup function that removes all registered event listeners
  return () => {
    cleanupFunctions.forEach((cleanup) => cleanup());
  };
}
